import(/* webpackMode: "eager" */ "/workspace/manjappada-landing-web/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/workspace/manjappada-landing-web/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/workspace/manjappada-landing-web/node_modules/react-bootstrap/esm/Col.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/manjappada-landing-web/node_modules/react-bootstrap/esm/Container.js");
;
import(/* webpackMode: "eager" */ "/workspace/manjappada-landing-web/node_modules/react-bootstrap/esm/Row.js");
;
import(/* webpackMode: "eager" */ "/workspace/manjappada-landing-web/src/app/home/body/FullBody.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/manjappada-landing-web/src/app/home/components/about/index.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/manjappada-landing-web/src/app/home/components/footer/index.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/manjappada-landing-web/src/app/home/components/HeroSection/index.jsx");
;
import(/* webpackMode: "eager" */ "/workspace/manjappada-landing-web/src/app/home/components/membershipCard/memebrshipCard.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/manjappada-landing-web/src/app/home/components/results/index.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/manjappada-landing-web/src/app/home/components/updateScroll/index.jsx");
;
import(/* webpackMode: "eager" */ "/workspace/manjappada-landing-web/src/components/shared/arrowButton/ArrowButton.css");
;
import(/* webpackMode: "eager" */ "/workspace/manjappada-landing-web/src/app/home/components/news/NewsAndUpdates.css");
;
import(/* webpackMode: "eager" */ "/workspace/manjappada-landing-web/src/app/home/components/gallery/gallery.css");
;
import(/* webpackMode: "eager" */ "/workspace/manjappada-landing-web/src/components/shared/EmptyState/EmptyState.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/manjappada-landing-web/src/components/shared/imageGallery/imageModal.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/manjappada-landing-web/src/components/shared/navbar/index.jsx");
;
import(/* webpackMode: "eager" */ "/workspace/manjappada-landing-web/src/components/shared/youtubeGallery/YouTubeList.css");
